import { ComboboxItem, Group, Select } from '@mantine/core';

export interface HierarchyDisciplineSelectProps {
  disciplineOptions: ComboboxItem[];
  disciplineValue: string | null;

  userOptions: ComboboxItem[];
  userValue: string | null;

  onDisciplineChange: (_value: string | null, option: ComboboxItem) => void;
  onUserChange: (_value: string | null, option: ComboboxItem) => void;

  isDisabled?: boolean;
}

export function HierarchyDisciplineSelect(props: HierarchyDisciplineSelectProps) {
  const { disciplineOptions, disciplineValue, userOptions, userValue, onDisciplineChange, onUserChange, isDisabled } =
    props;

  return (
    <Group flex={1}>
      <Select
        flex={1}
        label="Disciplină"
        placeholder="Disciplină"
        data={disciplineOptions}
        searchable
        disabled={isDisabled}
        value={disciplineValue}
        onChange={onDisciplineChange}
      />
      <Select
        flex={1}
        label="Utilizatori"
        placeholder="Utilizatori"
        searchable
        data={userOptions}
        disabled={disciplineValue == null || isDisabled}
        value={userValue}
        onChange={onUserChange}
      />
    </Group>
  );
}
